// Server configuration - reads from environment variables
// Set these in your Bitbucket Pipeline or .env file
export const serverConfig = {
    name: process.env.REACT_APP_NAME || "localhost",
    url: process.env.REACT_APP_API_URL || "http://localhost:3006/v3",
    answersBaseURL: process.env.REACT_APP_ANSWERS_BASE_URL || "",
    resultBaseURL: process.env.REACT_APP_RESULT_BASE_URL || "http://localhost:3003/v3",
    proctoringURL: process.env.REACT_APP_PROCTORING_URL || "",
    azureStorageURL: process.env.REACT_APP_AZURE_STORAGE_URL || "https://v2testingstorage.blob.core.windows.net/user-videointerview/",
    azureSpeechStorageURL: process.env.REACT_APP_AZURE_SPEECH_STORAGE_URL || "https://v2testingstorage.blob.core.windows.net/user-speech-evaluation/",
    adminBackendURL: process.env.REACT_APP_ADMIN_BACKEND_URL || "http://localhost:3000",
    videoBackendURL: process.env.REACT_APP_VIDEO_BACKEND_URL || "https://video-api.myassesshub.com",
}

// Backward compatibility exports (deprecated - use serverConfig instead)
export const localhostConstants = serverConfig;
export const serverConstants = [serverConfig];